import isMobileJS from 'ismobilejs';

const isMobileResult = isMobileJS();
export const isMobile = isMobileResult.any;

const ua = navigator.userAgent;

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
  // @ts-ignore
  && !window.MSStream;

export const isEdge = () => /Edge/.test(navigator.userAgent);

export const isChrome = () => (ua.includes('Chrome') || ua.includes('Chromium')) && !isEdge();
export const isSafari = () => ua.includes('Safari') && !isChrome() && !isEdge();
export const isChromeIOS = () => isIOS() && isChrome();
